const MONTHS_FR = ["jan", "fév", "mar", "avr", "mai", "juin", "juil", "août", "sep", "oct", "nov", "déc"];

/** "2026-04-12" → "12 avr 2026" */
export function formatDate(iso?: string | null): string {
  if (!iso) return "—";
  const [y, m, d] = iso.split("-").map(Number);
  if (!y || !m || !d) return iso;
  return `${d} ${MONTHS_FR[m - 1]} ${y}`;
}

/** "2026-04-12" → ["12", "avr 2026"] for chip rendering */
export function splitDateForChip(iso?: string | null): [string, string] {
  if (!iso) return ["—", ""];
  const [y, m, d] = iso.split("-").map(Number);
  if (!y || !m || !d) return [iso, ""];
  return [String(d).padStart(2, "0"), `${MONTHS_FR[m - 1]} ${y}`];
}

/** "18:30:00" → "18:30" */
export function formatTime(iso?: string | null): string {
  if (!iso) return "";
  return iso.slice(0, 5);
}

/** Range "10:00 → 18:00" or single side */
export function formatTimeRange(start?: string | null, end?: string | null): string {
  const s = formatTime(start);
  const e = formatTime(end);
  if (s && e) return `${s} → ${e}`;
  if (s) return `dès ${s}`;
  if (e) return `jusqu'à ${e}`;
  return "";
}

export function formatPrice(value?: number | null): string {
  if (value === null || value === undefined) return "";
  if (value === 0) return "Gratuit";
  return new Intl.NumberFormat("fr-BE", { style: "currency", currency: "EUR" }).format(value);
}
